import { useEffect, useState } from "react";
import { ArrowRight, Phone, MapPin, Clock, CheckCircle2, Truck, Hammer, ShieldCheck, Calendar, Mail, Menu, X } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Fleet from "@/components/site/Fleet";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Landing() {
  useEffect(() => {
    document.title = "APOLODOR COM SRL — Stație de Betoane Fetești";
  }, []);

  return (
    <main className="min-h-screen bg-[#FAFAFA] text-[#0A0A0A] antialiased">
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Process />
      <Fleet />
      <Contact />
      <Footer />
    </main>
  );
}
